import "./Banner.css";

export default function Banner() {
    return (
        <section id="banner" aria-label="Baner główny">
            <picture>
                {/* AVIF (opcjonalnie, jeśli masz pliki) */}
                {/* <source
          srcSet="/banner/baner-2560x500.avif"
          media="(min-width: 1921px)"
          type="image/avif"
        />
        <source
          srcSet="/banner/baner-1920x500.avif"
          media="(min-width: 769px)"
          type="image/avif"
        />
        <source
          srcSet="/banner/baner-600x500.avif"
          media="(max-width: 768px)"
          type="image/avif"
        /> */}

                {/* WebP */}
                <source
                    srcSet="/banner/baner-2560x500-v2.avif"
                    media="(min-width: 1921px)"
                    type="image/webp"
                />
                <source
                    srcSet="/banner/baner-1920x500-v2.avif"
                    media="(min-width: 769px)"
                    type="image/webp"
                />
                <source
                    srcSet="/banner/baner-600x500-v2.avif"
                    media="(max-width: 768px)"
                    type="image/webp"
                />

                {/* Fallback src = wariant desktopowy; width/height rezerwują miejsce */}
                <img
                    src="/banner/baner-1920x500.avif-v2"
                    alt="Promocje i nowa kolekcja w LumeStore"
                    width="1920"
                    height="500"
                    loading="eager"
                    fetchpriority="high"
                    className="hero-banner"
                    decoding="async"
                />
            </picture>
        </section>
    );
}
